import React, { type FormEvent } from 'react';

import { HN_SKJEMA_FRONTEND_RESOURCES } from 'src/constants/constants';
import { useResources } from 'src/resources';
import { hentOversettelse } from 'src/util/stringToLanguageLocales';

import type { HNSkjemaFrontend } from 'src/types/Resources';

import HelpTrigger from '@helsenorge/designsystem-react/components/HelpTriggerIcon';

type Props = {
  openSidebar: (e: Event | FormEvent<unknown> | undefined) => void;
};

export const AnchorHelpTrigger = ({ openSidebar }: Props): React.JSX.Element | null => {
  const resources = useResources<HNSkjemaFrontend>(HN_SKJEMA_FRONTEND_RESOURCES);
  if (!resources) {
    return null;
  }
  return (
    <span id="anchor_title_helptrigger" className="atom_helptrigger-container" data-testid="anchor_title_helptrigger">
      <HelpTrigger ariaLabel={hentOversettelse('hjelpeknapp_ariaLabel', resources)} onClick={openSidebar} size="large" />
    </span>
  );
};
